export class PlaceDetailsElectricity {

  id: number;

  operatorName: string;
  code: string;
  placeType: string;

  isProsumer: boolean;

  conventionParties: string[];
  suppliers: string[];

  approvedConsumptionPower: number;
  voltageLevel: number;

  smartMeter: boolean;

  counterIndexReadDate: string;
  date: string;
  counterIndexDesc: string;
  counterIndexValue: string;
  counterSeries: string;
  number: string;
  connectionType: string;
  technicalDataStatus: string;
  counterType: string;
  networkType: string;
  operatingMode: string;
  counterIndexInterval: number;

  conventionType: string;
  conventionNumber: string;
  conventionDate: string;
  conventionPresent: boolean;

  clientIdentificationNumber: string;
  clientName: string;
  contractNumber: string;
  validFrom: string;
  validTo: string;
  contractType: string;


  streetNumber: string;
  streetName: string;
  postalCode: string;
  block: string;
  apartment: string;
  floor: string;
  county: number;
  city: number;
  countyName: string;
  cityName: string;

  connectionCertificate: boolean;
  connectionCertificateNumber: string;
  connectionCertificateDate: string;

  connectionNotice: boolean;
  connectionNoticeNumber: string;
  connectionNoticeDate: string;


}
